export const ADS_NEXTJS_APP_FEATURE_FLAG_NAME = 'ads_nextjs_app_enabled'

/**
 * Static mappings from Vue route path (to.path from Vue Router, without the # prefix)
 * to Next.js full URL path.
 */
const STATIC_VUE_TO_NEXT_MAP = {
  '/ads/dashboard': '/ads/dashboard',
  '/ads/ads-credit': '/ads/billing',
  '/ads/ads-credit/top-up': '/ads/billing/prepaid/top-up',
  '/ads/postpaid/invoice': '/ads/billing/postpaid/invoice',
  '/ads/postpaid/invoice/settings': '/ads/billing/postpaid/settings',
  '/ads/activity-logs': '/ads/activity',
  '/ads/create': '/ads/campaign-editor/new',
  '/ads/top-up-success': '/ads/billing/prepaid/top-up/success',
  '/ads/top-up-failed': '/ads/billing/prepaid/top-up/failure',
  '/ads/pay-now': '/ads/billing/prepaid/pay-now',
  '/ads/postpaid/pay-now': '/ads/billing/postpaid/pay-now',
  '/ads/postpaid/success': '/ads/billing/postpaid/pay-now/success',
  '/ads/postpaid/failure': '/ads/billing/postpaid/pay-now/failure',
}

/**
 * Dynamic route patterns for routes with parameters.
 * Each entry has a regex to match the Vue path and a function to build the Next.js URL.
 *
 * Note: The postpaid invoice pattern uses a negative lookahead to avoid matching
 * '/ads/postpaid/invoice/settings' (which is a static route).
 */
const DYNAMIC_VUE_TO_NEXT_PATTERNS = [
  {
    pattern: /^\/ads\/campaign-insights\/(.+)$/,
    toNextPath: (match) => `/ads/campaign-insights/${match[1]}`,
  },
  {
    pattern: /^\/ads\/detail\/(.+)$/,
    toNextPath: (match) => `/ads/campaign-editor/${match[1]}`,
  },
  {
    pattern: /^\/ads\/postpaid\/invoice\/(?!settings)(.+)$/,
    toNextPath: (match) => `/ads/billing/postpaid/invoice/${match[1]}`,
  },
  {
    pattern: /^\/ads\/conversion-orders\/(.+)$/,
    toNextPath: (match) => `/ads/conversion-orders/${match[1]}`,
  },
]

/**
 * Convert a Vue route path (to.path from Vue Router) to a Next.js full URL path.
 * Returns null if no mapping is found.
 *
 * @param {string} vuePath - The Vue route path (e.g., '/ads/dashboard')
 * @returns {string|null} The Next.js URL path (e.g., '/ads/dashboard') or null
 */
export function vuePathToNextUrl(vuePath) {
  // Check static mappings first
  if (STATIC_VUE_TO_NEXT_MAP[vuePath]) {
    return STATIC_VUE_TO_NEXT_MAP[vuePath]
  }

  // Check dynamic mappings
  for (const { pattern, toNextPath } of DYNAMIC_VUE_TO_NEXT_PATTERNS) {
    const match = vuePath.match(pattern)
    if (match) {
      return toNextPath(match)
    }
  }

  return null
}
